var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionDepositDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-whales"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3737 1.862H3.63141C3.12875 1.862 2.72125 2.22635 2.72125 2.67579V17.3241C2.72125 17.7735 3.12875 18.1378 3.63141 18.1378H16.3737C16.8764 18.1378 17.2838 17.7735 17.2838 17.3241V2.67579C17.2838 2.22635 16.8764 1.862 16.3737 1.862Z",
    stroke: "#DFDFDF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.14594 1.862H10.0007V8.71499L8.07334 7.00174L6.14594 8.71499V1.862Z",
    stroke: "#DFDFDF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.7123 14.7103H14.2822",
    stroke: "#DFDFDF",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10 12.1419L14.2831 12.1419",
    stroke: "#DFDFDF",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionDepositDark);
export default __webpack_public_path__ + "static/media/action-deposit-dark.8089c28359e7af29f14bb9ef7ed4d877.svg";
export { ForwardRef as ReactComponent };